import { render } from "./BottomNav.vue?vue&type=template&id=7b52ddca"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__